import { Tabs } from '@medeloop/medeloop-components-library';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageHeader } from 'src/components';

const BASE_DATASETS_URL = '/account/data';

export function DataPage() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <section className="flex flex-col max-w-right-section mx-auto px-6 xl:px-0">
      <PageHeader
        title="Data"
        description="Manage, curate, and maintain the raw data collections required for analysis"
      />
      <Tabs
        value={location.pathname.split('/').pop()}
        onValueChange={(value) => navigate(`${BASE_DATASETS_URL}/${value}`)}
      >
        <Tabs.List className="border-stroke-on-dark-subdued">
          <Tabs.Trigger value="datasets">Datasets</Tabs.Trigger>
          <Tabs.Trigger value="cohorts">Cohorts</Tabs.Trigger>
          <Tabs.Trigger value="codes">Codes</Tabs.Trigger>
        </Tabs.List>
        <Tabs.Content value="datasets">
          <Outlet />
        </Tabs.Content>
        <Tabs.Content value="cohorts">
          <Outlet />
        </Tabs.Content>
        <Tabs.Content value="codes">
          <Outlet />
        </Tabs.Content>
      </Tabs>
    </section>
  );
}
